import React, { useEffect, useState, useRef } from "react";
import { Table, Input, Select } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getCFDetails } from "../auth/services/privateapicalling";
import CommonStatusSelect, { Option } from "../application/CommonSelect";

interface StatusProp {
  status: any[];
  navigateTo?: string;
}
const ApplicationTable: React.FC<StatusProp> = ({ status }) => {
  const language = useSelector((state: any) => state.auth.language);
  const token = useSelector((state: any) => state.auth.token);
  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const roleIdentifier = userDetail?.Role?.Role_Identifier;
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
   const [selectedStatus, setSelectedStatus] = useState<Option | null>(status[0]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [appStatussssLvl, setAppStatussssLvl] = useState("")

  // Status counts
  const [statusCounts, setStatusCounts] = useState({
    total: 0,
    pending: 0,
    approved: 0,
    queried: 0,
  });

  // Set default filter based on role


  // Fetch data from API
  useEffect(() => {
    if (selectedStatus) {
      setCurrentPage(1); // Reset to first page when status changes
      fetchApplications(selectedStatus?.value, 0, pageSize);
    }
  }, [selectedStatus]);

  const fetchApplications = async (
    appStatusLevel: string,
    page: number = 0,
    limit: number = 10,
    search: string = ""
  ) => {
    setLoading(true);
    try {
      // Pass pagination and search parameters to your API
      const response = await getCFDetails(appStatusLevel, token);

      if (response.success) {
        const formattedData = response.data.map((item: any, index: number) => {
          const rawDate = item.createdAt || "";
          let formattedDate = "N/A";
          if (rawDate) {
            const d = new Date(rawDate);
            const day = String(d.getDate()).padStart(2, "0");
            const month = String(d.getMonth() + 1).padStart(2, "0");
            const year = d.getFullYear();
            formattedDate = `${day}-${month}-${year}`;
          }
          return {
            key: item.applicationId || index,
            SpID: item.applicationId,
            date: formattedDate,
            status: item.status,
            appStatusLevel: item.appStatusLevel,
            action: item.action,
          };
        });
        setAppStatussssLvl(appStatusLevel)
        setData(formattedData);
        setFilteredData(formattedData);
        setTotalCount(response.totalCount || 0);
        calculateStatusCounts(formattedData);
      }
    } catch (error) {
      
    } finally {
      setLoading(false);
    }
  };

  const calculateStatusCounts = (applications: any[]) => {
    const counts = {
      total: applications.length,
      pending: applications.filter((app) => app.status === "pending").length,
      approved: applications.filter((app) => app.status === "approved").length,
      queried: applications.filter((app) => app.status === "queried").length,
    };
    setStatusCounts(counts);
  };

  const handleRedirect = (applicationId: string) => {
    navigate(`/marketing-board-registration`, {
      state: {
        applicationId: applicationId,
      },
    });
  };
  const handleSPORedirect = (applicationId: string) => {
    navigate(`/registration-status`, {
      state: {
        applicationId: applicationId,
      },
    });
  };
  const handleMBMDRedirect = (applicationId: string) => {
    
    if(
      appStatussssLvl==="pendingAtSponsor" || appStatussssLvl==="all" ){
      navigate(`/sponsor-registration`, {
      state: {
        applicationId: applicationId,
      },
    });
    }
    else {
       navigate(`/marketing-board-registration`, {
      state: {
        applicationId: applicationId,
      },
    });
    }
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    setCurrentPage(1); // Reset to first page on search
    fetchApplications(selectedStatus?.value, 0, pageSize, value);
  };

  const handleStatusFilterChange =  (option: Option | null) => {
      setSelectedStatus(option);
      setCurrentPage(1); // Reset to first page when status changes
      fetchApplications(option?.value, 0, pageSize, searchText);
    };
  

  const handlePaginationChange = (page: number, pageSize: number) => {
    setCurrentPage(page);
    setPageSize(pageSize);
    // Convert 1-based page (from Ant Design) to 0-based page for API
    fetchApplications(selectedStatus?.value, page - 1, pageSize, searchText);
  };

  const columns = [
    {
      title: (
        <div style={{ whiteSpace: "normal" }}>
          Application Id
        </div>
      ),
      dataIndex: "SpID",
      render: (text: string) => (
        <h6 className="fw-medium">
          <Link to="#">{text}</Link>
        </h6>
      ),
    },
    {
      title: (
        <div style={{ whiteSpace: "normal" }}>
          Applied Date
        </div>
      ),
      dataIndex: "date",
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: (
        <div style={{ whiteSpace: "normal" }}>
          Status
        </div>
      ),
      dataIndex: "status",
      render: (text: string) => (
        <span
          className={` ${
            text === "pending"
              ? "text-warning"
              : text === "approved"
              ? "text-success"
              : text === "permanentReject"
              ? "text-danger"
              : ""
          }`}
        >
          {text==="reject"?"Query Raised" : text==="permanentReject"?"Permanent Reject" : text.charAt(0).toUpperCase() + text.slice(1)}
        </span>
      ),
    },
    {
      title: "Action (Review)",
      dataIndex: "action",
      render: (action: boolean, record: any) =>
        action ? (
          <button
            className="btn btn-info w-25 fs-18 p-1"
            onClick={() => handleRedirect(record.SpID)}
          >
            Review
          </button>
        ) : (
          roleIdentifier==="MBMD"
          ?
          (
            <button
            className="btn btn-info w-25 fs-18 p-1"
            onClick={() => handleMBMDRedirect(record.SpID)}
          >
            Review
          </button>
          ):
           roleIdentifier==="SPO"
          ?
          (
            <button
            className="btn btn-info w-25 fs-18 p-1"
            onClick={() => handleSPORedirect(record.SpID)}
          >
            Review
          </button>
          ):
          (
           <span className="text-muted">No Action</span>
          )
        ),
    },
  ];

  return (
    <>
      
        <div>
          <div className="content">
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Registered Application Review</h2>
              </div>
            </div>

           {/* {
            !(roleIdentifier==="SPO") ?
            ( <div
              className="d-flex justify-content-between mb-3"
              style={{ fontSize: "1.25rem" }}
            >
              <div
                className="col-3 bg-info-subtle rounded-3 p-3"
                style={{ height: "150px", width: "300px" }}
              >
                Total Applications
                <h1 className="text-info" style={{ fontSize: "3rem" }}>
                  {statusCounts.total.toString().padStart(2, "0")}
                </h1>
              </div>
              <div
                className="col-3 bg-warning-subtle rounded-3 p-3"
                style={{ height: "150px", width: "300px" }}
              >
                Pending
                <h1 className="text-warning" style={{ fontSize: "3rem" }}>
                  {statusCounts.pending.toString().padStart(2, "0")}
                </h1>
              </div>
              <div
                className="col-3 border-secondary bg-secondary-subtle rounded-3 p-3"
                style={{ height: "150px", width: "300px" }}
              >
                Approved
                <h1 className="text-success" style={{ fontSize: "3rem" }}>
                  {statusCounts.approved.toString().padStart(2, "0")}
                </h1>
              </div>
              <div
                className="col-3 bg-dark-subtle rounded-3 p-3"
                style={{ height: "150px", width: "300px" }}
              >
                Queried
                <h1 className="text-secondary" style={{ fontSize: "3rem" }}>
                  {statusCounts.queried.toString().padStart(2, "0")}
                </h1>
              </div>
            </div>):""
           } */}

            <div className="card">
              <div className="card-body p-0">
                <div className="table-top-data">
                  <div className="row p-3">
                   
                          <CommonStatusSelect
              options={status}
              value={selectedStatus} // Use value instead of defaultValue
              onChange={handleStatusFilterChange}
              className="w-25 custom-select me-4"
            />
                     
                  
                    <div className="col-sm-6 d-flex justify-content-end">
                      <Input
                        placeholder="Search Application Id..."
                        style={{ width: 250 }}
                        allowClear
                        value={searchText}
                        onChange={(e) => handleSearch(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <Table
                  className="table datanew dataTable no-footer"
                  columns={columns}
                  rowHoverable={false}
                  dataSource={filteredData}
                  rowKey={"SpID"}
                  loading={loading}
                  pagination={{
                    locale: { items_per_page: "" },
                    nextIcon: <i className="ti ti-chevron-right" />,
                    prevIcon: <i className="ti ti-chevron-left" />,
                    current: currentPage,
                    pageSize: pageSize,
                    total: totalCount,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                    onChange: handlePaginationChange,
                    onShowSizeChange: handlePaginationChange,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
    
    </>
  );
};

export default ApplicationTable;